import { render, staticRenderFns } from "./ProfileDetail.vue?vue&type=template&id=0a173976&scoped=true"
import script from "./ProfileDetail.vue?vue&type=script&lang=js"
export * from "./ProfileDetail.vue?vue&type=script&lang=js"
import style0 from "./ProfileDetail.vue?vue&type=style&index=0&id=0a173976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a173976",
  null
  
)

export default component.exports